import { useEffect, useState } from "react";

import api from "@/api/admin";
import useAdminStore from "@/services/store/useAdminStore";
import errorHandler from "@/utilities/errorHandler";

// I have just seen this now after rebase. This will have to be added from the BE too
const useOpenOTP = () => {
  const { adminNotification } = useAdminStore();
  const [otpStatus, setOtpStatus] = useState(null);

  const getOtpStatus = async () => {
    try {
      const response = await api.auth.get.retrieveOtpInfo();
      setOtpStatus(response);
    } catch (error) {
      adminNotification.add({
        type: adminNotification.types.ERROR,
        timeoutToClose: 10,
        message: errorHandler(error),
      });
    }
  };

  useEffect(() => {
    getOtpStatus();
  }, []);

  const { is_valid, valid_until } = otpStatus || {};

  const endTime = valid_until ? new Date(valid_until).toISOString() : "";
  const currentTime = new Date().toISOString();

  return !is_valid || endTime <= currentTime;
};

export default useOpenOTP;
